import React from "react";
import { ModalContainer, ModalHeader, ModalFooter, CloseButton, StorageWrapper } from "./CleanupModal.styled";
import StorageStatus from "../StorageStatus";
import TextView from "../../TextView";
import Button from "../../Button";
import CleanupIcon from "../../../assets/images/cleanup-mop.svg";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import { deleteAllMedia } from "../../../services/api";
import { toast } from "react-toastify";

const CleanupModal = ({ onClose, storageUsed, storagePercent, totalStorage }) => {
    const handleDeleteAll = async () => {
        console.log("Deleting media:");

        try {
            const response = await deleteAllMedia();
            console.log("Delete response:", response);

            if (response.data && response.data.success) {
                console.log('success')
                toast.success(response.data.message)
            } else {
                console.warn("Deletion failed:", response.data);
                toast.error(response.data.message)
            }
            onClose()
        } catch (error) {
            console.error("Error deleting media:", error.response ? error.response.data : error.message);
            onClose()
        }
    };

    return (
        <ModalContainer>
            <ModalHeader>
                <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center" }}>
                    <img src={CleanupIcon} alt="Cleanup Icon" />
                    <TextView variant="title" color="black">Cleanup Space</TextView>
                </div>
                <CloseButton onClick={onClose}>
                    <CloseIcon fontSize="small" sx={{ color: "grey" }} />
                </CloseButton>
            </ModalHeader>

            <Divider sx={{ my: 1, backgroundColor: "#E0E0E0" }} />

            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <TextView variant="largeText" color="#6B6F80" style={{ fontWeight: "500" }}>Remove all unused media files</TextView>
                <StorageWrapper>
                    <StorageStatus storageUsed={storageUsed} storagePercent={storagePercent} totalStorage={totalStorage} />
                </StorageWrapper>
                <TextView variant="largeText" color="#6B6F80" style={{ fontWeight: "500" }}>This cannot be reversed</TextView>
            </div>

            <Divider sx={{ my: 2, backgroundColor: "#E0E0E0" }} />

            <ModalFooter>
                <Button onClick={onClose} secondary style={{ width: "auto", padding: "0 12px" }}>Cancel</Button>
                <Button style={{ width: "auto", padding: "0 12px" }} onClick={() => handleDeleteAll()}>Confirm</Button>
            </ModalFooter>
        </ModalContainer>
    );
};

export default CleanupModal;
